import type { RuleTopic } from '../vacationHelp.types';
import { APPROVAL_LEAD_DAYS } from '@/features/Vacations/utils/vacationApprovalDeadline';
import { APPROVAL_ALERT_DAYS } from '@/features/Vacations/utils/panorama/constants';

export const APPROVAL_RULES: RuleTopic[] = [
    {
        id: 'your-role',
        icon: '👔',
        title: 'Seu papel no fluxo',
        summary: 'O que você faz como gestor de férias e day-offs.',
        content: (
            <div className="space-y-3 text-sm">
                <p>Colaboradores solicitam férias e day-off de aniversário. Você aprova ou reprova.</p>
                <p>Seu pedido vai junto com o do cliente (em paralelo). Depois segue para o Departamento Pessoal, que faz a validação final.</p>
                <p className="font-semibold text-blue-700">
                    💡 Os pedidos que você não respondeu ficam na seção "Já respondidas por você" (com os que você já decidiu).
                </p>
            </div>
        ),
    },
    {
        id: 'deadline',
        icon: '⏰',
        title: 'Prazo para decidir',
        summary: `Você tem ${APPROVAL_LEAD_DAYS} dias antes do início das férias.`,
        content: (
            <div className="space-y-3 text-sm">
                <p>Se você não decidir nos <strong>{APPROVAL_LEAD_DAYS} dias</strong> antes do início, o sistema recusa <strong>automaticamente</strong>.</p>
                <p><strong>Âmbar:</strong> {APPROVAL_ALERT_DAYS} dias ou menos. <strong>Vermelho:</strong> 7 dias ou menos, ou quando vence. Mais urgente.</p>
                <p className="text-gray-600 text-xs mt-2">
                    Você recebe lembretes por e-mail aos 60, 30 e 15 dias do prazo, depois diariamente.
                </p>
            </div>
        ),
        facts: [
            { label: 'Prazo total', value: `${APPROVAL_LEAD_DAYS} dias` },
            { label: 'Âmbar', value: `≤ ${APPROVAL_ALERT_DAYS} dias` },
            { label: 'Vermelho', value: '≤ 7 dias' },
        ],
    },
    {
        id: 'day-off',
        icon: '🎂',
        title: 'Day-off de aniversário',
        summary: 'Uma folga por ano, no dia do aniversário.',
        content: (
            <div className="space-y-3 text-sm">
                <p>O day-off aparece no mesmo carrossel das férias, com a etiqueta <strong>Day-off</strong>. Use o filtro de tipo para ver só um deles.</p>
                <p>Em vez do prazo das férias, o cartão mostra <strong>Expira em</strong>: se ninguém decidir até a data do day-off, ele expira sozinho.</p>
                <p>Não dá para aprovar uma data que já passou. Ao reprovar, o motivo é obrigatório e o colaborador o vê.</p>
                <p className="text-gray-600 text-xs mt-2">
                    Depois da sua aprovação, o Departamento Pessoal lança a folga no ponto.
                </p>
            </div>
        ),
    },
    {
        id: 'conflicts',
        icon: '⚡',
        title: 'Conflito com alocação',
        summary: 'Quando as férias batem com projetos agendados.',
        content: (
            <div className="space-y-3 text-sm">
                <p>O sistema avisa quando as datas das férias sobrepõem com as alocações do próprio colaborador em um projeto.</p>
                <p>Não é bloqueio — você pode approvar mesmo assim. Mas revisa se a pessoa consegue sair nessa época.</p>
                <p className="text-gray-600 text-xs mt-2">
                    Aviso informativo. O Departamento Pessoal ou o cliente decidem se é um problema real.
                </p>
            </div>
        ),
    },
    {
        id: 'permissions',
        icon: '🚫',
        title: 'Regras da aprovação',
        summary: 'O que você faz e quem faz o resto.',
        content: (
            <div className="space-y-3 text-sm">
                <ul className="list-disc list-inside space-y-2">
                    <li><strong>Ao reprovar:</strong> motivo é obrigatório (mínimo 10 caracteres)</li>
                    <li><strong>Abono pecuniário:</strong> quem decide é o Departamento Pessoal, não você</li>
                    <li><strong>Data de início:</strong> se precisar mudar, o Departamento Pessoal faz isso em correção</li>
                    <li><strong>Sua própria solicitação:</strong> ninguém aprova a própria</li>
                </ul>
            </div>
        ),
    },
];
